const logoStyle = {
    logosize: {
        maxHeight: "100px",
    }
};

export default logoStyle;